import injectSheet from 'react-jss'
import SeatTradeTradesOverview from './SeatTradeTradesOverview'
import styles from './SeatTradeTradesOverview.styles'

export default injectSheet(styles)(SeatTradeTradesOverview)
